import React from 'react';
import {
  string, shape, number, func,
} from 'prop-types';
import Alert from '@active/react-ui/Alert';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import Locale from '@active/react-utils/i18n/Locale';
import { currency } from '../../../../../../../Currency';
import { dateTime } from '../../../../../../../DateTime';
import getFailPaymentReason from './failPaymentReasonConfig';

const FailPaymentInfo = ({
  i18n,
  failPaymentReasonType,
  amount,
  currencyCode,
  failPaymentDate,
  locale,
}) => {
  if (amount === undefined) {
    return null;
  }

  const failPaymentAmount = currency({ amount, code: currencyCode, locale });
  const failPaymentDateTime = dateTime({ date: failPaymentDate, locale });
  const failPaymentReason = i18n(getFailPaymentReason(failPaymentReasonType));
  const values = { 0: failPaymentDateTime, 1: failPaymentAmount, 2: failPaymentReason };
  return (
    <Alert theme="inline" type="warning" className="failPayment-message cui-mg-t-20">
      <Locale id="checkout.lib.components.paymentOption.failPaymentReason" params={values} />
    </Alert>
  );
};

FailPaymentInfo.propTypes = {
  failPaymentReasonType: string,
  amount: number,
  currencyCode: string,
  failPaymentDate: shape({
    time: number,
    timeZoneOffset: number,
  }),
  locale: string,
  i18n: func.isRequired,
};

FailPaymentInfo.defaultProps = {
  failPaymentDate: {},
};

export default withI18n(FailPaymentInfo);
